export const INDUSTRIES = [
  {
    title: 'INDUSTRIAL',
    desc: 'Protecting critical infrastructure and industrial operations with reliable and compliant pest management solutions.',
  },
  {
    title: 'COMMERCIAL',
    desc: 'Safe and effective pest solutions for businesses of every size.',
  },
  {
    title: 'AGRICULTURAL',
    desc: 'Supporting the agriculture industry with targeted solutions that protect crops and storage.',
  },
]

export const VALUES = [
  {
    title: 'SPECIALTY EXPERTISE',
    desc: 'Focused on complex environments and unique pest challenges.',
  },
  {
    title: 'COMPLIANCE DRIVEN',
    desc: 'Built around industry regulations, food safety, and audit readiness.',
  },
  {
    title: 'CUSTOM SOLUTIONS',
    desc: 'Programs tailored to your operation, risks, and pest pressure.',
  },
  {
    title: 'RESPONSIVE SUPPORT',
    desc: 'Local teams, fast response, and ongoing communication.',
  },
]
